import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6a0f9ab3 from 'nuxt_plugin_plugin_6a0f9ab3' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_45d87f78 from 'nuxt_plugin_bootstrapvue_45d87f78' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_f505a1dc from 'nuxt_plugin_pluginutils_f505a1dc' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5e238046 from 'nuxt_plugin_pluginrouting_5e238046' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_e175fe9c from 'nuxt_plugin_pluginmain_e175fe9c' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_index_76a5bfd0 from 'nuxt_plugin_index_76a5bfd0' // Source: ./infinitescroll/components/index.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_feb7bb48 from 'nuxt_plugin_nuxtleaflet_feb7bb48' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_workbox_2b910125 from 'nuxt_plugin_workbox_2b910125' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7e3d5338 from 'nuxt_plugin_metaplugin_7e3d5338' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_fa360ea8 from 'nuxt_plugin_iconplugin_fa360ea8' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_2755fa49 from 'nuxt_plugin_axios_2755fa49' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_outdooractiveclient_332bd52a from 'nuxt_plugin_outdooractiveclient_332bd52a' // Source: ../plugins/outdooractive.client.js (mode: 'client')
import nuxt_plugin_outdooractivedetailclient_53c3d33b from 'nuxt_plugin_outdooractivedetailclient_53c3d33b' // Source: ../plugins/outdooractivedetail.client.js (mode: 'client')
import nuxt_plugin_localtourenclient_6538ad58 from 'nuxt_plugin_localtourenclient_6538ad58' // Source: ../plugins/localtouren.client.js (mode: 'client')
import nuxt_plugin_localtourendetailsclient_73269d2c from 'nuxt_plugin_localtourendetailsclient_73269d2c' // Source: ../plugins/localtourendetails.client.js (mode: 'client')
import nuxt_plugin_thomasclient_2a7ccb58 from 'nuxt_plugin_thomasclient_2a7ccb58' // Source: ../plugins/thomas.client.js (mode: 'client')
import nuxt_plugin_modalclient_59a0dbd6 from 'nuxt_plugin_modalclient_59a0dbd6' // Source: ../plugins/modal.client.js (mode: 'client')
import nuxt_plugin_cursorclient_59215dac from 'nuxt_plugin_cursorclient_59215dac' // Source: ../plugins/cursor.client.js (mode: 'client')
import nuxt_plugin_globalsclient_07d89350 from 'nuxt_plugin_globalsclient_07d89350' // Source: ../plugins/globals.client.js (mode: 'client')
import nuxt_plugin_infiniteloading_68d2fb1c from 'nuxt_plugin_infiniteloading_68d2fb1c' // Source: ../plugins/infiniteloading (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../plugins/aos.js (mode: 'client')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_datepicker_f86071f6 from 'nuxt_plugin_datepicker_f86071f6' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_multiselect_25a96358 from 'nuxt_plugin_multiselect_25a96358' // Source: ../plugins/multiselect.js (mode: 'client')
import nuxt_plugin_vuedragscroll_61ed6ece from 'nuxt_plugin_vuedragscroll_61ed6ece' // Source: ../plugins/vue-dragscroll.js (mode: 'client')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../plugins/vue-lazyload.js (mode: 'client')
import nuxt_plugin_vuelightbox_36530636 from 'nuxt_plugin_vuelightbox_36530636' // Source: ../plugins/vue-lightbox.js (mode: 'client')
import nuxt_plugin_submitRequest_3891d6b6 from 'nuxt_plugin_submitRequest_3891d6b6' // Source: ../plugins/submitRequest.js (mode: 'client')
import nuxt_plugin_route_192d86f8 from 'nuxt_plugin_route_192d86f8' // Source: ../plugins/route.js (mode: 'client')
import nuxt_plugin_auth_699e7c72 from 'nuxt_plugin_auth_699e7c72' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"RheinWelten","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"RheinWelten verläuft vom Oberalppass bis zur Grenze in Basel entlang des Rheins. In 14 Erlebniswelten entdecken Reisebegeisterte mit dem E-Bike regionale, kulinarische und kulturelle Highlights. Jetzt entdecken ✓"},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fpng","href":"\u002Ftouch-icon-iphone.png"},{"rel":"icon","sizes":"60x60","href":"\u002Fbookmark.png"},{"rel":"icon","sizes":"16x16","href":"\u002Fbookmark.png"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6a0f9ab3 === 'function') {
    await nuxt_plugin_plugin_6a0f9ab3(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_45d87f78 === 'function') {
    await nuxt_plugin_bootstrapvue_45d87f78(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_f505a1dc === 'function') {
    await nuxt_plugin_pluginutils_f505a1dc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5e238046 === 'function') {
    await nuxt_plugin_pluginrouting_5e238046(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_e175fe9c === 'function') {
    await nuxt_plugin_pluginmain_e175fe9c(app.context, inject)
  }

  if (typeof nuxt_plugin_index_76a5bfd0 === 'function') {
    await nuxt_plugin_index_76a5bfd0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_feb7bb48 === 'function') {
    await nuxt_plugin_nuxtleaflet_feb7bb48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_2b910125 === 'function') {
    await nuxt_plugin_workbox_2b910125(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7e3d5338 === 'function') {
    await nuxt_plugin_metaplugin_7e3d5338(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_fa360ea8 === 'function') {
    await nuxt_plugin_iconplugin_fa360ea8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2755fa49 === 'function') {
    await nuxt_plugin_axios_2755fa49(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_outdooractiveclient_332bd52a === 'function') {
    await nuxt_plugin_outdooractiveclient_332bd52a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_outdooractivedetailclient_53c3d33b === 'function') {
    await nuxt_plugin_outdooractivedetailclient_53c3d33b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localtourenclient_6538ad58 === 'function') {
    await nuxt_plugin_localtourenclient_6538ad58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localtourendetailsclient_73269d2c === 'function') {
    await nuxt_plugin_localtourendetailsclient_73269d2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_thomasclient_2a7ccb58 === 'function') {
    await nuxt_plugin_thomasclient_2a7ccb58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modalclient_59a0dbd6 === 'function') {
    await nuxt_plugin_modalclient_59a0dbd6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cursorclient_59215dac === 'function') {
    await nuxt_plugin_cursorclient_59215dac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalsclient_07d89350 === 'function') {
    await nuxt_plugin_globalsclient_07d89350(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_68d2fb1c === 'function') {
    await nuxt_plugin_infiniteloading_68d2fb1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_f86071f6 === 'function') {
    await nuxt_plugin_datepicker_f86071f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_multiselect_25a96358 === 'function') {
    await nuxt_plugin_multiselect_25a96358(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedragscroll_61ed6ece === 'function') {
    await nuxt_plugin_vuedragscroll_61ed6ece(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelightbox_36530636 === 'function') {
    await nuxt_plugin_vuelightbox_36530636(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_submitRequest_3891d6b6 === 'function') {
    await nuxt_plugin_submitRequest_3891d6b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_192d86f8 === 'function') {
    await nuxt_plugin_route_192d86f8(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_699e7c72 === 'function') {
    await nuxt_plugin_auth_699e7c72(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
